import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { appHttpClient } from '@framework';
import { environment as env } from 'environments/environment';
import { ResourceModel } from '@models';


@Injectable()
export class DictionaryServices {
    private get _endpoint() { return env.app_apiURL + '/dictionary' }

    constructor( @Inject('appHttpClient') private _httpClient: appHttpClient) { }

    Find(_dictionary?: any) {

        let _endpoint = this._endpoint;
        if (_dictionary) {
            _endpoint += '?' + _dictionary.toQueryParamData();
        }
        return this._httpClient.Get(_endpoint)
            .map(res => res.json());
    }

    GetProjectResources(_ProjectID) {
        let _endpoint = this._endpoint + '/resources' + '/' + _ProjectID;
        return this._httpClient.Get(_endpoint).map(res => res.json());
    }

    GetInstanceResources(_dictionary? : ResourceModel) {
        let _endpoint = this._endpoint + '/resources';

        if (_dictionary) {
            _endpoint += '?' + _dictionary.toQueryParamData();
        }

        return this._httpClient.Get(_endpoint)
            .map(res => res.json());
    }


    GetApplicationLanguages() {
        let _endpoint = this._endpoint + '/application/languages';
        return this._httpClient.Get(_endpoint)
            .map(res => res.json());
    }

};


@Injectable()
export class DictionaryResourceServices {
    private get _endpoint() { return env.app_apiURL + '/dictionary/resources' }

    constructor( @Inject('appHttpClient') private _httpClient: appHttpClient) { }

    GetResourceMetaData() {

        return Observable.create((_operator) => {
            this._httpClient.Get(this._endpoint + '/modeldata')
                .subscribe(
                (_data: any) => {
                    const _response = _data.json();
                    const ResouceModel = _response;
                    // TODO Ask odysseas how to avoid _body
                    // let ResouceModel = JSON.parse(_data._body)
                    _operator.next(ResouceModel);
                }, (_error) => { _operator.error(_error); }
                );
        });
    }

    Insert(_ResourceData): any {
        return this._httpClient.Post(`${this._endpoint}`, JSON.stringify(_ResourceData));
    }


    Update(_ResourceData): any {
        return this._httpClient.Put(`${this._endpoint}`, JSON.stringify(_ResourceData));
    }

    delete(_ProjectID , _Resource): any {
        return this._httpClient.Delete(`${this._endpoint}/${_ProjectID}/${_Resource}`);
    }

};
